/* Comparativa "Skindion vs otros tratamientos" (sección 12 de la PDP,
   sesión 10). Copy aprobado: docs/PROMPT-SESION-10.md + maqueta
   https://lapis-lotus-sy5f.here.now/

   Las 6 pestañas viven AQUÍ y no inline en el HTML por lo mismo que
   js-reviews-amazon.js: el CDN cachea el asset y el HTML de cada visita
   a la PDP no engorda. La pestaña Bótox además la renderiza el Liquid
   en servidor (primer paint sin JS y sin saltos): si se toca su copy,
   hay que tocarlo en los DOS sitios.

   La sexta ("Microcorriente en clínica", 2026-08-16) absorbe la
   comparación que hacía la sección product-comparativa-clinica
   (eliminada): tiene su propio nombre de fila de precio (priceName),
   NO lleva fila "a medida" (attack es opcional) y dice "por uso" y no
   "por sesión" en el lado Skindion: un uso doméstico no se equipara a
   una sesión profesional.

   Este script solo re-renderiza al cambiar de pestaña, con la MISMA
   estructura de nodos que el Liquid y siempre por createElement +
   textContent — nada de innerHTML.

   PORT MX (2026-08-21): precios en MXN. Rivales = rangos canon del doc
   "Customer Persona #1 · Patricia · México" §20 (Notion smartlink-one,
   espejo en docs/notion/2026-08-08-customer-persona-patricia-mx.md):
   bótox $21,000-50,000+/año · lifting $70,000-165,000 · radiofrecuencia
   $550-3,300/sesión · hilos $5,500-25,000 · cremas $6,000-20,000/año.
   Microcorriente en cabina ($800-2,000/sesión) no está en Patricia: sale
   de research web 2026 (Body Lab CDMX ~$850, spalifegc). Lado Skindion =
   Protocolo Firmeza $1,649 / ~$18 por sesión (canon del money model: 250 g =
   90 sesiones). Igual que en ES: la pestaña Bótox vive TAMBIÉN en el
   Liquid (server-render) — tocar los DOS. */
(function () {
  'use strict';

  /* Cada fila de palomitas: [true = ✓ verde | false = ✗ gris, 'nota corta']. */
  var TABS = {
    botox: {
      label: 'Bótox',
      price: { skin: ['$1,649', '~$18 / sesión'], rival: ['$21,000 – $50,000 / año', 'de por vida'] },
      rows: [
        { name: 'Trata la raíz: el músculo', skin: [true, 'gym facial'], rival: [false, 'paraliza el músculo'] },
        { name: 'Desde casa, sin citas', skin: [true, ''], rival: [false, 'cita cada 3-4 meses'] },
        { name: 'Sin agujas ni cortes', skin: [true, ''], rival: [false, ''] },
        { name: 'Sin efectos secundarios', skin: [true, ''], rival: [false, 'párpado caído, asimetría'] },
        { name: '60 días de prueba', skin: [true, ''], rival: [false, ''] }
      ],
      attack: { name: 'Resultado natural', skin: [true, ''], rival: [false, 'riesgo de cara congelada'] },
      concede: 'Se lo concedemos al bótox: congela líneas de expresión en días. Lo que no hace es devolver firmeza.'
    },
    cirugia: {
      label: 'Cirugía',
      price: { skin: ['$1,649', '~$18 / sesión'], rival: ['$70,000 – $165,000', 'o más'] },
      rows: [
        { name: 'Trata la raíz: el músculo', skin: [true, 'gym facial'], rival: [false, 'corta y tensa'] },
        { name: 'Desde casa, sin citas', skin: [true, ''], rival: [false, 'quirófano + recuperación'] },
        { name: 'Sin agujas ni cortes', skin: [true, ''], rival: [false, 'bisturí y anestesia'] },
        { name: 'Sin efectos secundarios', skin: [true, ''], rival: [false, 'cicatrices, irreversible'] },
        { name: '60 días de prueba', skin: [true, ''], rival: [false, ''] }
      ],
      attack: { name: 'Resultado natural', skin: [true, ''], rival: [false, 'riesgo de efecto operada'] },
      concede: 'Se lo concedemos a la cirugía: es lo más potente que existe. También es lo único sin vuelta atrás.'
    },
    radio: {
      label: 'Radiofrecuencia',
      price: { skin: ['$1,649', '~$18 / sesión'], rival: ['$550 – $3,300 / sesión', 'en paquetes recurrentes'] },
      rows: [
        { name: 'Trata la raíz: el músculo', skin: [true, 'gym facial'], rival: [false, 'no llega al músculo'] },
        { name: 'Desde casa, sin citas', skin: [true, ''], rival: [false, 'citas en cabina'] },
        { name: 'Sin agujas ni cortes', skin: [true, ''], rival: [true, ''] },
        { name: 'Sin efectos secundarios', skin: [true, ''], rival: [false, 'quemaduras leves'] },
        { name: '60 días de prueba', skin: [true, ''], rival: [false, ''] }
      ],
      attack: { name: 'Sesiones ilimitadas', skin: [true, ''], rival: [false, 'cada sesión se paga'] },
      concede: 'Se lo concedemos a la radiofrecuencia, calienta tu piel. Pero el calor no fortalece. Lo que se calienta se enfría; lo que se entrena se queda.'
    },
    hilos: {
      label: 'Hilos tensores',
      price: { skin: ['$1,649', '~$18 / sesión'], rival: ['$5,500 – $25,000', 'cada 12-18 meses'] },
      rows: [
        { name: 'Trata la raíz: el músculo', skin: [true, 'gym facial'], rival: [false, 'tracción, no tonifica'] },
        { name: 'Desde casa, sin citas', skin: [true, ''], rival: [false, 'clínica + molestias'] },
        { name: 'Sin agujas ni cortes', skin: [true, ''], rival: [false, 'cánulas bajo la piel'] },
        { name: 'Sin efectos secundarios', skin: [true, ''], rival: [false, 'cicatrices y recuperación'] },
        { name: '60 días de prueba', skin: [true, ''], rival: [false, ''] }
      ],
      attack: { name: 'Resultado natural', skin: [true, ''], rival: [false, 'hilos sintéticos'] },
      concede: 'Se lo concedemos a los hilos: el efecto se ve al salir de la clínica. Pero toca de nuevo cada año.'
    },
    cremas: {
      label: 'Cremas y sérums',
      price: { skin: ['$1,649', '~$18 / sesión'], rival: ['$6,000 – $20,000 / año', 'de por vida'] },
      rows: [
        { name: 'Trata la raíz: el músculo', skin: [true, 'gym facial'], rival: [false, 'solo la superficie'] },
        { name: 'Desde casa, sin citas', skin: [true, ''], rival: [true, ''] },
        { name: 'Sin agujas ni cortes', skin: [true, ''], rival: [true, ''] },
        { name: 'Sin efectos secundarios', skin: [true, ''], rival: [true, ''] },
        { name: '60 días de prueba', skin: [true, ''], rival: [false, ''] }
      ],
      attack: { name: 'Levanta y da firmeza', skin: [true, ''], rival: [false, 'hidratan, no levantan'] },
      concede: 'Se lo concedemos a las cremas: hidratan y protegen. Pero la flacidez no está en la piel: está debajo.'
    },
    micro: {
      label: 'Microcorriente en clínica',
      priceName: 'Modelo de coste',
      price: { skin: ['$1,649, una vez', '~$18 / uso'], rival: ['$800 – $2,000 por sesión', 'o paquete'] },
      rows: [
        { name: 'Usa microcorriente facial', skin: [true, 'en casa'], rival: [true, 'uso profesional'] },
        { name: 'Desde casa, sin citas', skin: [true, '5 min en casa'], rival: [false, 'requiere cita'] },
        { name: 'Frecuencia en tus manos', skin: [true, '5 días / semana'], rival: [false, 'según cita y presupuesto'] },
        { name: 'El dispositivo es tuyo', skin: [true, 'lo conservas'], rival: [false, 'pagas el servicio'] },
        { name: 'Sin agujas ni cortes', skin: [true, 'no invasivo'], rival: [true, 'no invasivo'] },
        { name: '60 días de prueba', skin: [true, ''], rival: [false, 'sesión consumida'] }
      ],
      concede: 'Se lo concedemos a la clínica: una profesional realiza la sesión por ti. Con Skindion, tú decides cuándo y con qué frecuencia usar el dispositivo.'
    }
  };

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function varTh(name) {
    var th = el('th', 'pct__var', name);
    th.setAttribute('scope', 'row');
    return th;
  }

  function mark(ok) {
    var span = el('span', ok ? 'pct__mark pct__mark--yes' : 'pct__mark pct__mark--no', ok ? '✓' : '✗');
    span.setAttribute('role', 'img');
    span.setAttribute('aria-label', ok ? 'Sí' : 'No');
    return span;
  }

  function markCell(skin, data) {
    var td = el('td', skin ? 'pct__cell pct__cell--skin' : 'pct__cell');
    td.appendChild(mark(data[0]));
    if (data[1]) td.appendChild(el('span', 'pct__note', data[1]));
    return td;
  }

  function priceCell(skin, data) {
    var td = el('td', skin ? 'pct__cell pct__cell--skin' : 'pct__cell');
    td.appendChild(el('span', skin ? 'pct__price' : 'pct__price pct__price--rival', data[0]));
    td.appendChild(el('span', 'pct__price-sub', data[1]));
    return td;
  }

  function buildRows(tab) {
    var frag = document.createDocumentFragment();

    var price = el('tr', 'pct__row pct__row--price');
    price.appendChild(varTh(tab.priceName || 'Precio real'));
    price.appendChild(priceCell(true, tab.price.skin));
    price.appendChild(priceCell(false, tab.price.rival));
    frag.appendChild(price);

    tab.rows.forEach(function (row) {
      var tr = el('tr', 'pct__row');
      tr.appendChild(varTh(row.name));
      tr.appendChild(markCell(true, row.skin));
      tr.appendChild(markCell(false, row.rival));
      frag.appendChild(tr);
    });

    if (tab.attack) {
      var attack = el('tr', 'pct__row pct__row--attack');
      attack.appendChild(varTh(tab.attack.name));
      attack.appendChild(markCell(true, tab.attack.skin));
      attack.appendChild(markCell(false, tab.attack.rival));
      frag.appendChild(attack);
    }

    return frag;
  }

  function select(root, key) {
    var tab = TABS[key];
    if (!tab) return;

    var pills = root.querySelectorAll('[data-pct-tab]');
    for (var i = 0; i < pills.length; i++) {
      pills[i].setAttribute('aria-pressed', pills[i].getAttribute('data-pct-tab') === key ? 'true' : 'false');
    }

    var rivalHead = root.querySelector('[data-pct-rival]');
    if (rivalHead) rivalHead.textContent = tab.label;

    var body = root.querySelector('[data-pct-body]');
    if (body) {
      while (body.firstChild) body.removeChild(body.firstChild);
      body.appendChild(buildRows(tab));
    }

    var concede = root.querySelector('[data-pct-concede]');
    if (concede) concede.textContent = tab.concede;
  }

  /* Delegación en document: sobrevive a los re-renders de sección del
     editor de themes sin necesidad de re-inicializar nada. */
  document.addEventListener('click', function (event) {
    var pill = event.target && event.target.closest ? event.target.closest('[data-pct-tab]') : null;
    if (!pill) return;
    var root = pill.closest('[data-pct]');
    if (!root) return;
    select(root, pill.getAttribute('data-pct-tab'));

    /* En el carrusel móvil, la elegida se centra sola; en la rejilla
       de escritorio no hay overflow y esto no hace nada. */
    var tabsBox = pill.closest('.pct__tabs');
    if (tabsBox && tabsBox.scrollWidth > tabsBox.clientWidth + 1) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      pill.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
    }
  });
})();
